// const def_prompt = `The following is a transcript of an interview dialogue. Please extract the last question asked by the interviewer and provide an answer. If it is an algorithm question, please provide the approach and code implementation. If no question is found, there is no need to respond.`


function gpt_system_prompt() {
    return localStorage.getItem("gpt_system_prompt")
}

function azure_language() {
    return localStorage.getItem("azure_language") || "en-US"
}

function azure_region() {
    return localStorage.getItem("azure_region") || "eastasia"
}

function gpt_model() {
    return localStorage.getItem("gpt_model") || "gpt-5-mini"
}

function ai_provider() {
    return localStorage.getItem("ai_provider") || "openai"
}

function api_base_url() {
    return localStorage.getItem("api_base_url") || "https://api.openai.com/v1"
}

function custom_model_id() {
    return localStorage.getItem("custom_model_id") || ""
}

function openrouter_api_key() {
    return localStorage.getItem("openrouter_api_key") || ""
}

function custom_api_key() {
    return localStorage.getItem("custom_api_key") || ""
}

function google_api_key() {
    return localStorage.getItem("google_api_key") || ""
}

function groq_api_key() {
    return localStorage.getItem("groq_api_key") || ""
}

function xiaomi_api_key() {
    return localStorage.getItem("xiaomi_api_key") || ""
}

function cloudflare_api_key() {
    return localStorage.getItem("cloudflare_api_key") || ""
}

function cloudflare_account_id() {
    return localStorage.getItem("cloudflare_account_id") || ""
}

function vercel_api_key() {
    return localStorage.getItem("vercel_api_key") || ""
}

function vercel_project_id() {
    return localStorage.getItem("vercel_project_id") || ""
}

// Base URL configuration for each provider
function openai_base_url() {
    return localStorage.getItem("openai_base_url") || "https://api.openai.com/v1"
}

function openrouter_base_url() {
    return localStorage.getItem("openrouter_base_url") || "https://openrouter.ai/api/v1"
}

function vercel_base_url() {
    return localStorage.getItem("vercel_base_url") || "https://ai-gateway.vercel.sh/v1"
}

function google_base_url() {
    return localStorage.getItem("google_base_url") || "https://generativelanguage.googleapis.com/v1beta/openai"
}

function xiaomi_base_url() {
    return localStorage.getItem("xiaomi_base_url") || "https://api.xiaomimimo.com/v1"
}

function cloudflare_base_url(accountId) {
    const stored = localStorage.getItem("cloudflare_base_url")
    if (stored) return stored
    if (accountId) return `https://api.cloudflare.com/client/v4/accounts/${accountId}/ai/v1`
    return ""
}

function groq_base_url() {
    return localStorage.getItem("groq_base_url") || "https://api.groq.com/openai/v1"
}

export default {
    gpt_system_prompt,
    azure_language,
    azure_region,
    gpt_model,
    ai_provider,
    api_base_url,
    custom_model_id,
    openrouter_api_key,
    custom_api_key,
    google_api_key,
    groq_api_key,
    xiaomi_api_key,
    cloudflare_api_key,
    cloudflare_account_id,
    vercel_api_key,
    vercel_project_id,
    openai_base_url,
    openrouter_base_url,
    vercel_base_url,
    google_base_url,
    xiaomi_base_url,
    cloudflare_base_url,
    groq_base_url
}